import styled from "styled-components";
import HomeBackgroundImage from "@/assets/home/background.svg";
import { designTokens, getTypography } from "../../../styles/designTokens";

export const BackgroundWrapper = styled.div<{ showImage: boolean }>`
  position: absolute;
  inset: 0;
  overflow: hidden;
  background-image: ${({ showImage }) =>
    showImage ? `url(${HomeBackgroundImage})` : "none"};
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 3% center;
`;

export const Container = styled.div`
  width: 100%;
`;

export const HeroSection = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  margin: 0 auto;

  @media (max-width: 1280px) {
    flex-direction: column;
    height: 1350px;
  }
`;

export const HeroTitle = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  width: 50%;
  height: 100%;
  padding: 182px 100px;
  box-sizing: border-box;

  h1 {
    font-size: 36px;
    font-weight: 600;
    margin-bottom: 16px;
    word-wrap: break-word;
  }

  p {
    ${getTypography("korean", "title1")}
    margin-bottom: 40px;
    color: black;
    word-wrap: break-word;
  }

  button {
    padding: 16px 60px;
    border-radius: 16px;
    border: none;
    background-color: #4b5eff;
    color: white;
    font-size: 20px;
    font-weight: 600;
    cursor: pointer;
  }

  @media (max-width: 1280px) {
    width: 100%;
    height: auto;
    padding: 150px 50px;
    box-sizing: border-box;
    text-align: center;
    align-items: center;
  }
`;

export const HeroImage = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  width: 50%;
  height: 100%;
  position: relative;

  img {
    position: absolute;
    opacity: 1;

    &:nth-child(1) {
      z-index: 2;
      right: 0px;
      transition: transform 1s ease, opacity 1s ease;
      max-width: 676px;
    }

    &:nth-child(2) {
      z-index: 1;
      right: 0;
      transition: transform 1s ease, opacity 1s ease;
      max-width: 676px;
    }

    &.hidden {
      opacity: 0;
      transform: translateY(50px);
    }

    &.visible {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @media (max-width: 1280px) {
    width: 100%;
    height: 100%;
    img {
      position: absolute;
      object-fit: contain;
      width: auto;
      height: auto;

      &:nth-child(1) {
        width: auto;
        height: 65%;
        max-width: 90%;
      }

      &:nth-child(2) {
        width: auto;
        right: 0;
        height: 100%;
        max-width: 70%;
      }
    }
  }
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 40px;
  align-items: center;
  width: 100%;
  height: 482px;
  z-index: 2;
  background: linear-gradient(180deg, #4b5eff 0%, #5728ff 100%);

  h2 {
    ${getTypography("korean", "headline1")}
    margin: 0;
    color: white;
  }

  p {
    font-size: 28px;
    font-weight: 500;
    text-align: center;
    line-height: 200%;
    color: white;
    margin: 0;
  }

  span {
    display: block;
  }
`;

export const Section2 = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 120px 72px 80px 72px;
  z-index: 2;
`;

export const GifSection = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  background: #4b5eff12;
  padding: 80px 0 120px 0;
  z-index: 2;

  img {
    max-width: 1160px;
    width: 100%;
    height: 100%;
    object-fit: contain;
    margin: 0 auto;
  }
`;

export const ProductTag = styled.div`
  height: 42px;
  display: flex;
  background: ${designTokens.colors.box.secondary};
  justify-content: center;
  align-items: center;
  color: white;
  padding: 9px 20px;
  border-radius: 10px;
  ${getTypography("english", "title3")}
  font-weight: 600;
  margin-bottom: 15px;
  white-space: nowrap;
`;

export const Title = styled.h1`
  ${getTypography("english", "headline1")}
  margin-bottom: 120px;
  text-align: center;

  span {
    ${getTypography("korean", "headline1")}
  }
`;

export const FeaturesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 70px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 32px;
  }
`;

export const FeatureCard = styled.div`
  display: flex;
  flex-direction: column;
  width: 270px;
  height: 298px;
  background: white;
  padding: 0 30px;
  border-radius: 12px;
  text-align: center;
  justify-content: center;
  align-items: center;
  transition: transform 0.2s ease;
  gap: 31px;
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.12);

  &:hover {
    transform: translateY(-5px);
  }
`;

export const FeatureContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 28px;
`;

export const FeatureTitle = styled.div`
  ${getTypography("korean", "title1")}
  color: #4b5eff;
`;

export const FeatureDescription = styled.div`
  ${getTypography("korean", "body2")}
`;

export const LearnMore = styled.a`
  ${getTypography("korean", "body2")}
  text-decoration: none;
  color: #4b5eff;
`;
